<div class="popup-main popup--overlay" style="display: flex;">
    <div class="popup">

        <button class="popup--close"><span class="icon-cross" (click)="closePop()"></span></button>

        <div class="popup__content">
            <h6>Thrive Skills:</h6>
            <p>Thrive Skills are cognitive, social and emotional skills that every professional needs to succeed at the workplace. Harappa’s 75 Thrive Skills are drawn from the latest research on essential workplace competencies, conversations with talent development experts and our views on what it takes to make an impact at work.</p>
            <hr>
            <h6>Thrive Skill Scores:</h6>
            <p>Each Touchstone assessment question in a Program has a predefined score—Thrive Score—based on the application of a particular Thrive Skill. The maximum possible score for any Thrive Skill is 100. The higher the score, the better the performance on a Thrive Skill. Every correct answer improves the Thrive Score. You will receive a combined Thrive Score for each Thrive Skill at the end of the Program.</p>
        </div>
    </div>
</div>